module.exports = __webpack_public_path__ + "static/sofa-5d13c4eb45097079303b0a5f1a780123.png";